import React, { FC } from 'react';
import Form from 'components/Form';

import { VeetPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Veet: FC<VeetPageProps> = ({ pageContext, location }) => (
  <Form {...{
    ...{ ...pageContext, location, translations: { ...pageContext.translations, pageTitle: '' } },
  }} />
);

export default Veet;
